<template>
  <ion-segment
    :value="defaultValue"
    :color="darkText ? 'primary' : undefined"
    @ion-change="(e) => $emit('changeSegment', e)"
  >
    <ion-segment-button
      v-for="segmentButton in segmentList"
      :key="'segment-' + segmentButton.value"
      :value="segmentButton.value"
    >
      <ion-label
        :class="{
          'text-[11px] font-medium': segmentList.length > 2,
          'base-xs-medium': segmentList.length <= 2
        }"
      >
        {{ segmentButton.label }}
      </ion-label>
    </ion-segment-button>
  </ion-segment>
</template>

<script lang="ts" setup>
import { IonSegment, IonSegmentButton, IonLabel, SegmentChangeEventDetail } from '@ionic/vue';
import { useUserStore } from '@/store/user';
import { storeToRefs } from 'pinia';

defineProps<{
  segmentList: {
    value: string;
    label: string;
  }[];
  defaultValue: string;
}>();

defineEmits<{
  (e: 'changeSegment', payload: Event & { detail: SegmentChangeEventDetail }): void
}>();
const userStore = useUserStore();
const { darkText } = storeToRefs(userStore);
</script>

<style scoped>
ion-segment {
  --background: var(--ion-color-secondary);
  border-radius: 16px;
  height: 32px;
}

ion-segment-button {
  --indicator-color: var(--ion-color-secondary-shade);
  --color: var(--ion-custom-text-color);
  --border-radius: 16px;
  min-height: 26px;
  height: 26px;
  margin: 3px 1px;
}

ion-label {
  margin-top: 2px;
}
</style>
